module.exports = __webpack_public_path__ + "static/logo-8b25e5dac6d3a72df7b05301c5715c01.svg";